/**
 * Household slice — the current household context the user is acting in.
 *
 * Ported from legacy `useStore.ts` (`household`, `setHousehold`).
 *
 * The Household type lives here for now — legacy declares it in
 * `services/householdService.ts`, which will move to `@shopista/shared/api`
 * in T7 (web shell port). When that port lands, the type moves to
 * `@shopista/shared/types` and this file imports it.
 */

export interface Household {
  id: string;
  name: string;
  invite_code: string;
  store_discovery_available?: boolean;
  latitude?: number;
  longitude?: number;
  address?: string;
  city?: string;
  state_province?: string;
  country?: string;
  postal_code?: string;
  discovery_radius_km: number;
  created_at: string;
  updated_at: string;
}

export interface HouseholdState {
  household: Household | null;
}

export const initialHouseholdState: HouseholdState = {
  household: null,
};

// ---------------------------------------------------------------------------
// Actions
// ---------------------------------------------------------------------------

export function setHousehold(
  state: HouseholdState,
  input: { household: Household | null }
): HouseholdState {
  return { ...state, household: input.household };
}
